import $ from './jq';


const loading = () => {
  const $loading = $('.j-loading');
  const $loadingText = $('.j-loading-text');
  const $videoIn = $('#j-video-in');
  let num = 0;
  let timer = null;
  let count = 0;

  const showPage = () => {
    clearInterval(timer);
    $loadingText.text('100%');
    $('.j-loading-man-full').css('opacity', '1');
    $loading.fadeOut();
    if (!window.platform.isPhone()) {
      $videoIn[0].play();
    }
  };

  $(function () {
    let percent = '';
    timer = setInterval(() => {
      // 如满了99后还未onload再等3秒后结束加载
      if (num == 99 && count++ > 30) {
        showPage();
        return;
      }
      num < 99 && num++;
      percent = num + '%';
      $loadingText.text(percent);
      $('.j-loading-man-full').css('opacity', percent);
    }, 100);
  });
  window.addEventListener('load', () => {
    showPage();
  });
};

export default loading;
